import type { FC } from 'react';
import type { SelectUpgradePlanProps } from './common';
import { UpgradeTeamPlan } from './upgrade-team-plan';

/** 购买space套餐弹窗 */
export const SelectUpgradePlan: FC<SelectUpgradePlanProps> = (props) => {
  return <UpgradeTeamPlan {...props} />;
};
